import React from 'react';
import PolicyPage from './PolicyPage';

const sections = [
  {
    heading: 'Merchant Information',
    paragraphs: [
      'TUR DER HOFFNUNG operates this website and related payment services from 50 Rawdon Street, Freetown, Sierra Leone.',
      'TIN: 1001205375. Company No: SL280624TURDE22311. Website: https://turderhoffnung.com.',
    ],
  },
  {
    heading: 'Use of Website',
    paragraphs: [
      'By using this website, you agree to use it only for lawful purposes and in a way that does not infringe the rights of other users or interfere with normal website operation.',
      'You agree that all information you provide during inquiries or payments is accurate, complete, and up to date.',
    ],
  },
  {
    heading: 'Services and Payments',
    paragraphs: [
      'All services, offers, and pricing displayed on this website are subject to availability and confirmation.',
      'Payments made through the payment page are processed securely. TUR DER HOFFNUNG reserves the right to refuse or cancel a transaction if fraud, unauthorized activity, or compliance issues are suspected.',
    ],
  },
  {
    heading: 'Liability',
    paragraphs: [
      'TUR DER HOFFNUNG will make reasonable efforts to keep the website accurate and available, but does not guarantee uninterrupted access at all times.',
      'To the extent permitted by law, TUR DER HOFFNUNG is not liable for indirect, incidental, or consequential damages arising from the use of this website or related services.',
    ],
  },
];

export default function TermsPage() {
  return (
    <PolicyPage
      title="Terms & Conditions"
      subtitle="Terms & Conditions"
      sections={sections}
    />
  );
}
